module.exports = {
  de: process.env.DOMAIN_DE,
  at: process.env.DOMAIN_AT,
  ch: process.env.DOMAIN_CH,
  nl: process.env.DOMAIN_NL,
  es: process.env.DOMAIN_ES,
};
